// Prevent duplicate class declaration
if (typeof window.VirtualTryOn === "undefined") {
  window.VirtualTryOn = class VirtualTryOn extends HTMLElement {
    constructor() {
      super();

      this.loader = this.querySelector(".loading-overlay");
      this.swatches = this.querySelector(".YMK-swatchs");
      this.addToCart = this.querySelector("add-to-cart");
      this.ymkEventsBound = false;

      this.VirtualTryOnSdk = new VirtualTryOnSdk();

      theme.initWhenVisible({
        element: this,
        callback: this.init.bind(this),
        threshold: 200,
      });
    }

    init() {
      this.VirtualTryOnSdk.createYMKDiv(this);

      if (this.VirtualTryOnSdk.isYMKModuleLoaded && window.YMK) {
        YMK.close();
        this.initEvents();
        YMK.openHandAR(true);
      } else {
        const isLoading = this.VirtualTryOnSdk.loadYMKModule(
          this,
          this.initEvents.bind(this),
        );

        if (!isLoading && this.loader) {
          this.loader.classList.add("hidden");
        }
      }
    }

    initEvents() {
      this.registerYMKEvents();
      this.initSwatch();
    }

    registerYMKEvents() {
      if (this.ymkEventsBound || !window.YMK) return;

      this.ymkEventsBound = true;

      YMK.addEventListener(
        "loading",
        function (progress) {
          // console.log('progress VTO in section');
          const progressBar = this.loader?.querySelector(
            '[role="progressbar"]',
          );
          if (progressBar) {
            progressBar.style = "--value: " + progress;
          }
        }.bind(this),
      );

      YMK.addEventListener(
        "loaded",
        function () {
          // console.log('loaded VTO in section');
          setTimeout(() => {
            if (this.loader) {
              this.loader.classList.add("hidden");
            }
            const moduleContainer = this.querySelector(".YMK-module-container");
            if (moduleContainer) {
              moduleContainer.classList.remove("hidden");
            }
            if (this.swatches) {
              this.swatches.classList.remove("hidden");
            }
          }, 1000);
        }.bind(this),
      );

      YMK.addEventListener(
        "closed",
        function () {
          // console.log('closed VTO in section');
          if (this.swatches) {
            this.swatches.classList.add("hidden");
          }
          if (this.loader) {
            this.loader.classList.remove("hidden");
            const progressBar = this.loader.querySelector(
              '[role="progressbar"]',
            );
            if (progressBar) {
              progressBar.style = "--value: 0";
            }
          }
          const moduleContainer = this.querySelector(".YMK-module-container");
          if (moduleContainer) {
            moduleContainer.classList.remove("hidden");
          }
        }.bind(this),
      );

      YMK.addEventListener(
        "opened",
        function () {
          // console.log('opened VTO in section');
          const moduleContainer = this.querySelector(".YMK-module-container");
          if (moduleContainer) {
            moduleContainer.classList.add("hidden");
          }
        }.bind(this),
      );
    }

    initSwatch() {
      if (this.swatches && this.swatches.querySelectorAll("input").length) {
        this.swatches.querySelectorAll("input").forEach((elm) => {
          if (elm.dataset.vtoBound === "true") return;

          elm.dataset.vtoBound = "true";
          elm.addEventListener("change", (evt) => {
            var el = evt.currentTarget;
            var sku = el.value;
            this.initAddToCart(el);
            if (window.YMK) {
              YMK.applyMakeupBySku(sku);
            }
          });
        });
      }
    }

    initAddToCart(el) {
      if (!this.addToCart || !el) return;

      this.toggleAddButton(true, "");
      this.addToCart.classList.remove("hidden");
      this.addToCart.dataset.variantId = el.dataset.variantId;
      setTimeout(() => {
        if (el.dataset.productAvailable == "true") {
          this.toggleAddButton(false, "");
        } else {
          this.toggleAddButton(true, theme.variantStrings.soldOut);
        }
      }, 200);
    }

    toggleAddButton(disable = true, text) {
      if (!this.addToCart) return;

      if (disable) {
        this.addToCart.classList.add("disabled");
        if (text) this.addToCart.textContent = text;
      } else {
        this.addToCart.classList.remove("disabled");
        this.addToCart.textContent =
          this.addToCart.dataset.preOrder === "true"
            ? theme.variantStrings.preOrder
            : theme.variantStrings.addToCart;
      }
    }
  };
} // End of VirtualTryOn class definition guard

// Only define the custom element if it hasn't been defined yet
if (!customElements.get('virtual-try-on')) {
  customElements.define("virtual-try-on", window.VirtualTryOn);
}

if (typeof module !== "undefined" && module.exports) {
  module.exports = window.VirtualTryOn;
} 
